import * as React from "react";
import { IAutoplayButton } from "../AutoplayButton";
import { SpinButton } from "../SpinButton";
import { StyledAutoplayButton } from "./components/AutoplayButton";

export interface ICombinedSpinButton extends IAutoplayButton {
  autoplayActive?: boolean;
  autoplayEnabled?: boolean;
  autoplayRunning?: boolean;
  hidden?: boolean;
  spinStarted?: boolean;
}

export const CombinedSpinButton = ({
  autoplayActive,
  autoplayEnabled,
  autoplayRunning,
  autoplayRoundsLeft,
  disabled,
  spinStarted,
  ...props
}: ICombinedSpinButton) => {
  return (autoplayActive && autoplayRunning) || autoplayEnabled ? (
    <StyledAutoplayButton
      {...props}
      disabled={!autoplayActive}
      autoplayRunning={autoplayRunning}
      autoplayRoundsLeft={autoplayRoundsLeft}
    />
  ) : (
    <SpinButton disabled={disabled} spinStarted={spinStarted} {...props} />
  );
};
